import * as React from 'react';
import { Grid, Box } from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { Switch, FormControlLabel } from '@mui/material';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { url, urlLive } from "../../constant";

function Settings() {
    // State for password fields
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [isEmailEnabled, setIsEmailEnabled] = React.useState(false); // State for email toggle

    // State for validation errors
    const [errors, setErrors] = React.useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    // State for API response and loading status
    const [isloading, setIsLoading] = React.useState(false);
    const [apiError, setApiError] = React.useState("");
    const [apiSuccess, setApiSuccess] = React.useState("");

    // State for API response and loading status
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        getEmailNotificationStatus();
    }, []);


    const handleEmailToggle = async () => {
        setIsEmailEnabled((prev) => !prev);

        const formdata = new FormData();
        formdata.append("email_notification_enabled", !isEmailEnabled);

        const requestOptions = {
            method: "POST",
            // headers: myHeaders,
            body: formdata,
        };

        try {
            const response = await fetch(`${url}auth/settings/email-notification`, requestOptions);
            const result = await response.json();

            if (response.ok) {

                if (result.success) {
                    getEmailNotificationStatus();
                    alert(result.message);
                }

            } else {

            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
            setIsLoading(false);
        }

    };

    const getEmailNotificationStatus = () => {
        
        setLoading(true);
        fetch(`${url}auth/settings/email-notification`)
            .then(response => response.json())
            .then(data => {
                console.log('EmailNotificationStatus :', data);
                setIsEmailEnabled(data.email_notification_enabled);
                setLoading(false);
            });

    };


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox style={{ backgroundColor: 'white', minHeight: '85vh' }} py={6}>
                <MDBox px={2} mx={2} mt={2}>
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} sm={8} md={6} lg={6}>
                            <MDBox mb={3} textAlign="center">
                                <MDTypography variant="h4" fontWeight="bold" color="text">
                                    {/* Settings */}
                                    Impostazioni
                                </MDTypography>
                                <MDTypography mt={2} variant="body2" color="textSecondary">
                                    {/* Select Whether to Enable Email Notifications */}
                                    Seleziona se abilitare le notifiche e-mail
                                </MDTypography>
                            </MDBox>

                            {/* Switch Button for Email Notifications */}
                            <MDBox mt={3} sx={{ borderRadius: 2, padding: 4, boxShadow: 2 }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={<Switch checked={isEmailEnabled} onChange={handleEmailToggle} />}
                                            // label={isEmailEnabled ? "Attiva le notifiche e-mail" : "Disattiva le notifiche e-mail"}
                                            label={isEmailEnabled ? "Notifiche attivate" : "Notifiche disattivate"}
                                        />
                                    </Grid>

                                </Grid>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
            </MDBox>

            {/* Loader - Backdrop */}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Footer />
        </DashboardLayout>
    );
}

export default Settings;
